/** Global middleware: Applies authentication and legacy redirect checks */

import { useMiddlewareAuth } from '@app/guards/authenticated.hook'
import { useMiddlewareAutoLogin } from '@app/guards/auto-login.hook'
import { useMiddlewareScopeFallback } from '@app/guards/scope-fallback.hook'
import { AppRoute } from '@shared/config'

import { defineNuxtRouteMiddleware } from '#app'

// FIXME: auth.ts
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/dev/preview')) {
    return
  }

  const signature = (to.query?.signature as string | undefined) ?? undefined

  if (signature) {
    const autoLoginTarget = await useMiddlewareAutoLogin(to, signature)
    if (autoLoginTarget) return navigateTo(autoLoginTarget, { replace: true })
    return navigateTo(AppRoute.Login)
  }

  const authResult = await useMiddlewareAuth(to)
  if (authResult) return authResult

  useMiddlewareScopeFallback(to)
})
